<template>
  <div>
    <div id="filterOptions" :style="filterOptionsStyles">
      <!-- prev -->
      <MenuPanel
        :menu-switch-speed="menuSwitchSpeed"
        :list="content_prevItem"
        :positionStyle="panel_prevPositionStyle"
        :isTranslating="isTranslating"
        :showHeaderArrow="prevItemHasParent"
      />

      <!-- staging -->
      <MenuPanel
        :menu-switch-speed="menuSwitchSpeed"
        :list="content_currentItem"
        :positionStyle="panel_stagingPositionStyle"
        :isTranslating="isTranslating"
        :showHeaderArrow="currentItemHasParent"
        :handleHeaderClicked="clickPrevItem"
        :handleItemClicked="clickNextItem"
      />

      <!-- next -->
      <MenuPanel
        :menu-switch-speed="menuSwitchSpeed"
        :list="content_nextItem"
        :positionStyle="panel_nextPositionStyle"
        :isTranslating="isTranslating"
        :showHeaderArrow="true"
      />
    </div>
  </div>
</template>

<script>
  import MenuPanel from "../../../nested_menu/MenuPanel";

  import panelControl from '../../../../mixins/nested_menu/panelControl.mixin';
  import contentControl from '../../../../mixins/nested_menu/contentControl.mixin';

  import { mapGetters, mapActions } from "vuex";

  export default {
    name: "filter-options",

    components: {
      MenuPanel
    },

    mixins: [
      panelControl,
      contentControl
    ],

    data() {
      return {
        isTranslating: false,
        default: {},

        childHeight: 55,
        headerHeight: 200,
        menuHeight: 0,
        menuSwitchSpeed: .3
      };
    },

    computed: {
      ...mapGetters([
        'filterOptions',
        'collectionFilter',
        'selectedFilterOptions'
      ]),
      filterOptionsStyles() {
        let styles = {
          height: `${this.menuHeight}px`
        };

        if (this.isTranslating) {
          styles['transition'] = `height ${this.menuSwitchSpeed}s`;
        }

        return styles;
      },
      currentItemHasParent() {
        return this.content_parentStack.length >= 1;
      },
      prevItemHasParent() {
        return this.content_parentStack.length >= 2;
      }
    },

    mounted() {
      const windowWidth = $(window).width();

      const collectionItem = this.getMenuCompatibleDataFromCategories(Object.values(this.filterOptions).filter(item => item.code === 'pris_collections'));

      this.content_currentItem = {
        filter: null,
        parent: null,
        children: collectionItem
      };

      if (this.selectedFilterOptions.length) {
        const selectedCollectionItem = this.getMenuCompatibleDataFromCategories(Object.values(this.selectedFilterOptions));

        this.content_currentItem = {
          filter: selectedCollectionItem[0].filter,
          parent: collectionItem[0].filter,
          children: selectedCollectionItem[0].children,
          title: selectedCollectionItem[0].title
        };

        this.content_prevItem = {
          filter: collectionItem[0].filter,
          parent: null,
          children: collectionItem[0].children,
          title: collectionItem[0].title
        };

        this.default = {
          filter: null,
          parent: null,
          children: collectionItem
        };

        this.content_parentStack = [this.default, this.content_prevItem];

      }

      const calculatedHeight = this.content_currentItem.children.length * this.childHeight + this.headerHeight;

      this.menuHeight = calculatedHeight;

      if(!this.selectedFilterOptions.length) {
        this.headerHeight = 50;
      }

      $(window).on('resize', this.onResize);
    },

    watch: {
      selectedFilterOptions() {
        if(!this.selectedFilterOptions.length) {
          this.menuHeight = 100;
        }
      }
    },

    methods: {
      ...mapActions([
        'toggleFilterOption'
      ]),
      onResize() {
        if ($(window).width() > 510) {
          this.updateFilterOptionHeight(this.content_currentItem);
        }
      },
      updateFilterOptionHeight(item) {
        let numChildren = item.children.length;

        // Account for "Show all" if necessary
        const parentIsCollections = item.parent && item.parent.code === 'pris_collections';
        const hasChildren = numChildren > 0;

        if (parentIsCollections && hasChildren) {
          numChildren++;
        }

        this.menuHeight = numChildren * this.childHeight + this.headerHeight;
      },
      getMenuCompatibleDataFromCategories(categories, parent = null) {
        return categories.filter(cat => cat.enabled)
          .map(cat => {
            return {
              title: cat.name,
              filter: cat,
              parent: parent,
              children: this.getMenuCompatibleDataFromCategories(cat.sub_categories, cat)
            };
          });
      },
      clickNextItem(targetItem) {
        if (this.isTranslating) return;

        // Handle clicking a filter (item with no children)
        if (targetItem.children.length === 0) {
          this.toggleFilterOption({
            clickedFilter: targetItem.filter,
            filterParent: targetItem.parent
          });

          return;
        }

        this.slideToNext(targetItem);
      },
      clickPrevItem() {
        if (this.isTranslating || !this.currentItemHasParent) {
          return;
        }

        this.slideToPrev();
      },

      /*
       * main part of core
       * definite of how to handle panel sliding and item updating
       */
      slideToNext(targetItem) {
        // set target item as content of next panel
        this.content_setNextItem(targetItem);

        // switch animation on
        this.setTranslating(true);

        // Adjust menu height
        this.updateFilterOptionHeight(targetItem);

        // activate panel sliding with animation after `.translating` class has updated to panel dom.
        this.$nextTick(() => {
          this.panel_slideNext();
        });

        // reset panel position
        this.homingAfterTranslatingNext();
      },
      slideToPrev() {
        // set prev item which is the parent of the current item.
        this.content_setPrevItem();

        // switch animation on
        this.setTranslating(true);

        // Adjust menu height
        this.updateFilterOptionHeight(this.content_prevItem);

        // activate panel sliding with animation after `.translating` class has updated to panel dom.
        this.$nextTick(() => {
          this.panel_slideBack();
        });

        // reset panel position
        this.homingAfterTranslatingBack();
      },

      // handle homing after slide animation end
      homingAfterTranslatingNext() {
        setTimeout(() => {
          // switch off transition state of panel
          this.setTranslating(false);

          // push current to parent stack
          this.content_pushCurrentToParentStack();

          // homing
          this.panel_homingPosition(); // reset panel position just like the beginning.
          this.content_homingItemAfterNext(); // change item between these panels to meet updated panel position.
        }, this.menuSwitchSpeed * 1000);
      },
      homingAfterTranslatingBack() {
        setTimeout(() => {
          this.setTranslating(false);

          // homing
          this.panel_homingPosition();
          this.content_homingItemAfterBack();
        }, this.menuSwitchSpeed * 1000);
      },

      // utils
      setTranslating(status) {
        this.isTranslating = status;
      },
    }
  }
</script>

<style lang="scss" scoped>
  #filterOptions {
    margin-bottom: 0;
    padding: 1px;
    width: 100%;
    position: relative;
    top: 0;
    overflow: hidden;
    border-radius: 6px;

    .filter-list {
      li {
        padding-top: 0;
        padding-bottom: 0;

        .filter-list-title,
        .filter-list-children li {
          padding: 12px 0;

          h4 {
            display: inline-block;
            margin-top: 5px;
          }

          @media screen and (min-width: 1200px) {
            padding: 10px 0;
          }
        }

        .filter-list-children {
          padding-left: 1px;

          li {
            padding-left: 8px;
            border-top: none;
            font-weight: 500;

            &:not(.filter-selected):hover {
              color: #f99839;
            }
          }
        }
      }
    }

    @media screen and (min-width: 510px) {
      display: block !important;
    }
  }
</style>
